// extracted by mini-css-extract-plugin
export default {"wrapper":"EditSocietyModal_wrapper__0R4MU","confirm":"EditSocietyModal_confirm__RJYuK","delete":"EditSocietyModal_delete__8D6BH"};